import { z } from "zod";
import i18next from "i18next";
import { FIELD_REQUIRED } from "../../../../../i18n/keysTranslations";
import {
  ADS_CAMPAIGN_OBJECTIVE_APP_PROMOTION_OPTION,
  ADS_CAMPAIGN_OBJECTIVE_SALES_OPTION,
} from "../../../../../utils/constants";

const metaBaseSchema = z.object({
  objective: z.string().min(1, i18next.t(FIELD_REQUIRED)),
  integrationID: z.string().min(1, i18next.t(FIELD_REQUIRED)),
  adAccountID: z.string().min(1, i18next.t(FIELD_REQUIRED)),
  pageID: z.string().min(1, i18next.t(FIELD_REQUIRED)),
  instagramID: z.string().optional(),
  useFBPageAsIG: z.boolean().optional(),

  useCampaignBudget: z.any().optional(),
  typeBudget: z.any().optional(),
  budget: z.any().optional(),

  isCatalogCampaign: z.boolean().default(false).optional(),
  whatsappBusinessNumber: z.any().optional(),
  messageTemplate: z.any().optional(),
  instantForm: z.any().optional(),

  trackingID: z.any().optional(),
  trackingCustomEventID: z.any().optional(),

  catalogID: z.any().optional(),
  isIOS14Campaign: z.any().optional(),
  appID: z.any().optional(),

  buyingType: z.any().optional(),
  kpiSettings: z.any().optional(),
});

export const metaCampaignSchema = metaBaseSchema.superRefine((data, ctx) => {
  if (data.useCampaignBudget) {
    if (!data.typeBudget) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ["typeBudget"],
        message: i18next.t(FIELD_REQUIRED),
      });
    }
    if (!data.budget) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ["budget"],
        message: i18next.t(FIELD_REQUIRED),
      });
    }
  }
  if (
    data.objective === ADS_CAMPAIGN_OBJECTIVE_SALES_OPTION &&
    data.isCatalogCampaign &&
    !data.catalogID
  ) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      path: ["catalogID"],
      message: i18next.t(FIELD_REQUIRED),
    });
  }
  if (
    data.objective === ADS_CAMPAIGN_OBJECTIVE_APP_PROMOTION_OPTION &&
    data.isIOS14Campaign &&
    !data.appID
  ) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      path: ["appID"],
      message: i18next.t(FIELD_REQUIRED),
    });
  }
});
